import { NgModule } from '@angular/core';
import { addNavMenuItem, SharedModule } from '@vendure/admin-ui/core';

@NgModule({
    imports: [SharedModule],
    providers: [
        addNavMenuItem(
            {
                id: 'search-stats-terms',
                label: 'Busca - Termos',
                routerLink: ['/extensions/search-stats/terms'],
                icon: 'search',
            },
            'settings'
        ),
        addNavMenuItem(
            {
                id: 'search-stats-products',
                label: 'Busca - Produtos',
                routerLink: ['/extensions/search-stats/products'],
                icon: 'bar-chart',
            },
            'settings'
        ),
    ],
})
export class SearchStatsNavModule {}
